module.exports = __webpack_public_path__ + "static/media/demo_track.3d916936.wav";